
export default function MustNotNull(v) {
    if(v === undefined || v === null || v === -1 || v === "") {
        return [true, "จำเป็นต้องระบุ"];
    }
    return [false, ""];
}